




























import { Component, Vue, Prop, Emit } from 'vue-property-decorator';

@Component
export default class TopContentSelect extends Vue {
  @Prop({ type: Array, required: true })
  public list!: {
    key: string;
    seqNo: number;
    page: number;
    text1: string;
    text2: string;
    text3: string;
  }[][];

  @Prop({ type: Array, required: true })
  public value!: string[];

  private get isMultipleTerm(): boolean {
    return this.list.length > 1;
  }

  private input(index: number, key: string) {
    const newValue: string[] = this.value.slice();
    newValue[index] = key;
    this.$emit('input', newValue);
  }
}
